import type { Recipient } from '@/types'

/**
 * What to call the writer of a thread comment.
 *
 * A member is named from the project's recipient list, so a rename shows up on
 * everything they ever wrote. `storedName` is the name frozen on the row
 * itself, and it is read only when there is no member to resolve: that is an
 * anonymous guest, and the string is what they typed for themselves (OCT-5090).
 *
 * "Guest" is the fallback for both an anonymous writer who gave no name and a
 * member the recipient list has no entry for — a distinction the header has
 * nowhere to draw and no reason to.
 */
export const getAuthorName = (
  user: Recipient | null,
  storedName: string | null
) => {
  const name = user?.fullName?.split(' ')

  if (name && name?.length > 2) {
    return `${name[0]} ${name[1].charAt(0)}`
  }

  if (name && name?.length > 1) {
    return name[0]
  }

  return storedName || 'Guest'
}
